import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    width: '100%',
  },
  divider: {
    width: '100%',
  },
  dividerStyle: {
    marginBottom: theme.spacing(-2),
  },
}))
